export const LogoMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <rect x="1.5" y="1.5" width="45" height="45" rx="10" stroke="url(#lg)" strokeWidth="1.5" />
    <path
      d="M30 16c-1.6-2.2-4.4-3.4-7.2-3.4-4 0-7 2.2-7 5.6 0 7.6 15 4.4 15 11.4 0 3.8-3.4 6-8 6-3.4 0-6.4-1.6-8-4.2"
      stroke="url(#lg)"
      strokeWidth="2.6"
      strokeLinecap="round"
    />
    <path d="M14 40h20" stroke="url(#lg)" strokeWidth="2" strokeLinecap="round" />
    <defs>
      <linearGradient id="lg" x1="0" y1="0" x2="48" y2="48">
        <stop stopColor="#F3E5AB" />
        <stop offset="1" stopColor="#D4AF37" />
      </linearGradient>
    </defs>
  </svg>
);

export const Logo = () => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark size={34} />
    <div className="leading-none">
      <span className="block font-display text-sm font-semibold tracking-[0.3em] text-slate-100">
        SKY SUITE
      </span>
      <span className="mt-1 block font-mono text-[9px] tracking-[0.45em] text-gold/80">
        RENTALS
      </span>
    </div>
  </div>
);
